import React, { useEffect, useState } from "react";
import { withAuthenticationRequired } from "../context/AuthContext";
import Loading from "../components/Loading";
import { TextField, Button, Switch } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { BiCalendarAlt } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { showErrorMessage, showSuccessMessage } from "../redux/appSlice";
import { useDispatch } from "react-redux";
import GoogleMapsSearch from "../components/GoogleMapsSearch";
import ImageUploadField from "../components/ImageUploadField";
import { useRequestHandler } from "../utils/useRequestHandler";
import Servicios from "../services";

export const Tablados = () => {
  const [tablados, setTablados] = useState([]);
  const [agregando, setAgregando] = useState(false);
  const [nombre, setNombre] = useState("");
  const [refreshGrilla, setRefreshGrilla] = useState(0);
  const [editando, setEditando] = useState(false);
  const [idEditando, setIdEditando] = useState(0);
  const center = { lat: -34.895033, lng: -56.165009 };
  const [marker, setMarker] = useState(center);
  const [direccion, setDireccion] = useState("");
  const [telefono, setTelefono] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [link, setLink] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const sendRequest = useRequestHandler();
  const [imagen, setImagen] = useState(null);
  const [imgPreviewSrc, setImgPreviewSrc] = useState("");
  const [incluirInactivos, setIncluirInactivos] = useState(false);

  const refrescarGrilla = () => {
    setRefreshGrilla(refreshGrilla + 1);
  };

  useEffect(() => {
    sendRequest(Servicios.ObtenerTablados, [incluirInactivos], data => {
      setTablados(data?.data);
    });
  }, [refreshGrilla, incluirInactivos]);

  const eliminarTablado = id => {
    sendRequest(Servicios.EliminarTablado, [id], data => {
      if (data?.data) {
        dispatch(showSuccessMessage("Tablado eliminado correctamente"));
        refrescarGrilla();
      }
    });
  };

  const toggleActivacionTablado = (id, event) => {
    sendRequest(
      Servicios.CambiarActivacionTablado,
      [id, event.target.checked],
      () => {
        refrescarGrilla();
      },
      () => event.stopPropagation()
    );
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 10 },
    { field: "nombre", headerName: "Nombre", flex: 80 },
    {
      field: "actionSwitch",
      headerName: "",
      sortable: false,
      minWidth: 10,
      align: "right",
      renderCell: params => {
        return (
          <Switch
            checked={params.row.activo}
            onChange={e => toggleActivacionTablado(params.row.id, e)}
            inputProps={{ "aria-label": "controlled" }}
          />
        );
      }
    },
    {
      field: "actionProgramacion",
      headerName: "",
      sortable: false,
      minWidth: 10,
      align: "right",
      renderCell: params => {
        const onClick = e => {
          navigate(`/programacion/${params?.row?.id}`);
        };

        return (
          <BiCalendarAlt
            size={28}
            className="action-icon"
            title="PROGRAMACIÓN"
            onClick={onClick}
          />
        );
      }
    },
    {
      field: "actionEdit",
      headerName: "",
      sortable: false,
      minWidth: 10,
      align: "right",
      renderCell: params => {
        const onClick = e => {
          setAgregando(true);
          setEditando(true);
          setNombre(params.row.nombre);
          setTelefono(params.row.telefono);
          setDireccion(params.row.direccion);
          setDescripcion(params.row.descripcion);
          setLink(params.row.link);
          setMarker({
            lat: params.row.latitud,
            lng: params.row.longitud
          });
          setIdEditando(params.row.id);
          setImagen(null);
          setImgPreviewSrc(params.row.imagenPath);
        };

        return <EditIcon className="action-icon" onClick={onClick} />;
      }
    },
    {
      field: "actionDelete",
      headerName: "",
      sortable: false,
      minWidth: 10,
      align: "right",
      renderCell: params => {
        const onClick = e => {
          if (window.confirm("¿Confirmás eliminar el Tablado?")) {
            eliminarTablado(params?.row?.id);
          }
        };

        return <DeleteIcon className="action-icon" onClick={onClick} />;
      }
    }
  ];

  const limpiarForm = () => {
    setNombre("");
    setTelefono("");
    setDireccion("");
    setDescripcion("");
    setLink("");
    setMarker(center);
    setImagen(null);
    setImgPreviewSrc("");
  };

  const handleGuardar = () => {
    if (editando) {
      sendRequest(
        Servicios.ModificarTablado,
        [
          {
            id: idEditando,
            nombre: nombre,
            direccion: direccion,
            telefono: telefono,
            descripcion: descripcion,
            longitud: marker.lng,
            latitud: marker.lat,
            link: link
          },
          imagen
        ],
        () => {
          limpiarForm();
          setEditando(false);
          setAgregando(false);
          refrescarGrilla();
          dispatch(showSuccessMessage("Tablado modificado correctamente"));
        }
      );
    } else {
      sendRequest(
        Servicios.CrearTablado,
        [
          {
            nombre: nombre,
            direccion: direccion,
            telefono: telefono,
            descripcion: descripcion,
            longitud: marker.lng,
            latitud: marker.lat,
            link: link
          },
          imagen
        ],
        () => {
          limpiarForm();
          setEditando(false);
          setAgregando(false);
          refrescarGrilla();
          dispatch(showSuccessMessage("Tablado creado correctamente"));
        }
      );
    }
  };

  return (
    <>
      <>
        {!agregando ? (
          <div className="card-modern">
            <div className="page-header">
              <h4 className="page-title">Listado de tablados</h4>
              <div className="flex items-center gap-3">
                <div className="flex items-center">
                  <Switch
                    checked={incluirInactivos}
                    onChange={e => setIncluirInactivos(!incluirInactivos)}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <span>Incluir inactivos</span>
                </div>
                <Button
                  variant={"contained"}
                  onClick={() => setAgregando(true)}
                >
                  Agregar
                </Button>
              </div>
            </div>
            <hr className="border-gray-200 dark:border-gray-700 my-4" />
            <div className="grid-wrapper w-full">
              {tablados?.length > 0 ? (
                <DataGrid
                  rows={tablados}
                  columns={columns}
                  checkboxSelection={false}
                  disableRowSelectionOnClick
                  paginationMode="server"
                />
              ) : (
                <h5>No se encontraron resultados</h5>
              )}
            </div>
          </div>
        ) : (
          <div className="card-modern">
            <div className="page-header">
              <h4 className="page-title">
                {editando ? "Modificar Tablado" : "Nuevo Tablado"}
              </h4>
            </div>
            <hr className="border-gray-200 dark:border-gray-700 my-4" />
            <div className="flex flex-col md:flex-row gap-4">
              <div className="flex-1 flex flex-col gap-4">
                <div className="mb-3">
                  <TextField
                    className="w-full"
                    size="small"
                    label="Nombre"
                    value={nombre}
                    onChange={e => setNombre(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <TextField
                    className="w-full"
                    size="small"
                    label="Teléfono"
                    value={telefono}
                    onChange={e => setTelefono(e.target.value)}
                  />
                </div>
                <div id="map" className="mb-3 w-full">
                  <GoogleMapsSearch
                    title="Ubicación"
                    texto={direccion}
                    setTexto={setDireccion}
                    marker={marker}
                    setMarker={setMarker}
                  ></GoogleMapsSearch>
                </div>
              </div>

              <div className="flex-1 flex flex-col gap-4">
                <ImageUploadField
                  value={imagen}
                  previewSrc={imgPreviewSrc}
                  onChange={(file, previewDataUrl) => {
                    setImagen(file);
                    setImgPreviewSrc(previewDataUrl);
                  }}
                  onError={message => dispatch(showErrorMessage(message))}
                  // La app la muestra siempre dentro de un círculo — forzar
                  // el recorte 1:1 acá evita que una foto no cuadrada
                  // (ej. copiada de un perfil de Instagram) se vea
                  // desencuadrada (ver auditoría de imágenes, 2026-09).
                  cropAspectRatio={1}
                />
                <TextField
                  className="w-full"
                  size="small"
                  label="Descripcion"
                  value={descripcion}
                  onChange={e => setDescripcion(e.target.value)}
                  multiline
                  rows={18}
                />
              </div>
            </div>
            <div className="mb-3 mt-4">
              <TextField
                className="w-full"
                size="small"
                label="Link"
                value={link}
                onChange={e => setLink(e.target.value)}
              />
            </div>
            <hr className="border-gray-200 dark:border-gray-700 my-4" />
            <div className="flex justify-between items-center">
              <div>
                <Button
                  variant={"outlined"}
                  onClick={() => {
                    limpiarForm();
                    setEditando(false);
                    setAgregando(false);
                  }}
                >
                  Cancelar
                </Button>
              </div>
              <div>
                <Button variant={"contained"} onClick={handleGuardar}>
                  Guardar
                </Button>
              </div>
            </div>
          </div>
        )}
      </>
    </>
  );
};

export default withAuthenticationRequired(Tablados, {
  onRedirecting: () => <Loading />
});
